module.exports = __webpack_public_path__ + "static/media/41.e00f0a80.png";